import { render, staticRenderFns } from "./S_order.vue?vue&type=template&id=2fa9cbea&scoped=true"
import script from "./S_order.vue?vue&type=script&lang=js"
export * from "./S_order.vue?vue&type=script&lang=js"
import style0 from "./S_order.vue?vue&type=style&index=0&id=2fa9cbea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9cbea",
  null
  
)

export default component.exports